import type { Core } from 'sip.js';

/**
 * Asks FreeSWITCH to send this user agent SIP INFO; without it mod_sofia never delivers the
 * queue's agent-connected INFO (see {@link isQueueAgentConnectedInfo}).
 */
export const SEND_INFO_SUPPORT_HEADER = 'X-FS-Support: send_info';

const QUEUE_WAIT_HEADER = 'X-CX-Queue-Wait';
const QUEUE_EVENT_HEADER = 'X-CX-Queue-Event';
const QUEUE_AGENT_CONNECTED_EVENT = 'agent-connected';

/**
 * Whether a 200 OK came from a queue answering the call to play hold music, rather than from a
 * person picking up. mod_callcenter answers every caller the moment it enters the queue.
 */
export function isQueueWaitAnswer(message: Pick<Core.IncomingMessage, 'getHeader'>): boolean {
  return readHeader(message, QUEUE_WAIT_HEADER)?.toLowerCase() === 'true';
}

/** Whether an in-dialog INFO reports that the queue has bridged this caller to an agent. */
export function isQueueAgentConnectedInfo(
  message: Pick<Core.IncomingMessage, 'getHeader'>,
): boolean {
  return readHeader(message, QUEUE_EVENT_HEADER)?.toLowerCase() === QUEUE_AGENT_CONNECTED_EVENT;
}

function readHeader(
  message: Pick<Core.IncomingMessage, 'getHeader'>,
  header: string,
): string | undefined {
  try {
    return message.getHeader(header)?.trim();
  } catch {
    return undefined;
  }
}
